module.exports = __webpack_public_path__ + "static/media/tow_truck_hover.e88af713.svg";